// Lightweight GA4 event helper. Safe no-op if gtag isn't loaded.
export const trackEvent = (name, params = {}) => {
  try {
    if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
      window.gtag('event', name, params);
    }
  } catch (e) {
    // never let analytics break the UX
  }
};
